import React, { useEffect } from 'react'

import { useAuthStore } from '@/features/user-login/useAuthStore.ts'

export function AuthProvider({
	initialAuth,
	children
}: {
	initialAuth: boolean
	children: React.ReactNode
}) {
	const setAuth = useAuthStore(state => state.setAuth)
	const setInitialized = useAuthStore(state => state.setInitialized)

	useEffect(() => {
		setAuth(initialAuth)
		setInitialized(true)
	}, [initialAuth, setAuth, setInitialized])

	return <>{children}</>
}
